const dropdownSelector = '[data-gohall-dropdown]';
const triggerSelector = '[data-gohall-dropdown-trigger]';
const panelSelector = '[data-gohall-dropdown-panel]';
const closeDelay = 140;
const closeTimers = new WeakMap();
const pointerActivatedDropdowns = new WeakSet();

const getDropdown = (target) => (target instanceof Element ? target.closest(dropdownSelector) : null);

const setOpen = (item, shouldOpen, restoreFocus = false) => {
  const trigger = item.querySelector(triggerSelector);
  const panel = item.querySelector(panelSelector);

  if (!(trigger instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) return;

  item.classList.toggle('is-open', shouldOpen);
  trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  panel.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');

  if (restoreFocus) trigger.focus();
};

const cancelClose = (item) => {
  const timer = closeTimers.get(item);
  if (timer === undefined) return;

  window.clearTimeout(timer);
  closeTimers.delete(item);
};

const closeDropdown = (item, restoreFocus = false) => {
  cancelClose(item);
  setOpen(item, false, restoreFocus);
};

const closeOtherDropdowns = (currentItem) => {
  document.querySelectorAll(`${dropdownSelector}.is-open`).forEach((openItem) => {
    if (openItem !== currentItem) closeDropdown(openItem);
  });
};

const openDropdown = (item) => {
  cancelClose(item);
  closeOtherDropdowns(item);
  setOpen(item, true);
};

const scheduleClose = (item) => {
  cancelClose(item);
  closeTimers.set(item, window.setTimeout(() => closeDropdown(item), closeDelay));
};

const movedWithin = (item, relatedTarget) => relatedTarget instanceof Node && item.contains(relatedTarget);

if (!window.gohallHeaderDropdownControllerReady) {
  window.gohallHeaderDropdownControllerReady = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest(triggerSelector) : null;
    const item = getDropdown(trigger);
    if (!(trigger instanceof HTMLButtonElement) || !(item instanceof HTMLElement)) return;

    if (trigger.getAttribute('aria-expanded') === 'true') closeDropdown(item);
    else openDropdown(item);
  });

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;

    const item = getDropdown(event.target);
    if (!(item instanceof HTMLElement) || movedWithin(item, event.relatedTarget)) return;
    openDropdown(item);
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType === 'touch') return;

    const item = getDropdown(event.target);
    if (!(item instanceof HTMLElement) || movedWithin(item, event.relatedTarget)) return;
    scheduleClose(item);
  });

  document.addEventListener('focusin', (event) => {
    const item = getDropdown(event.target);
    if (
      !(item instanceof HTMLElement) ||
      movedWithin(item, event.relatedTarget) ||
      pointerActivatedDropdowns.has(item)
    ) {
      return;
    }
    openDropdown(item);
  });

  document.addEventListener('focusout', (event) => {
    const item = getDropdown(event.target);
    if (!(item instanceof HTMLElement) || movedWithin(item, event.relatedTarget)) return;

    window.setTimeout(() => {
      if (!item.contains(document.activeElement)) closeDropdown(item);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const item = getDropdown(event.target);
    if (!(item instanceof HTMLElement) || !item.classList.contains('is-open')) return;

    event.preventDefault();
    closeDropdown(item, true);
  });

  document.addEventListener('pointerdown', (event) => {
    const item = getDropdown(event.target);
    const trigger = event.target instanceof Element ? event.target.closest(triggerSelector) : null;

    if (item && trigger) {
      pointerActivatedDropdowns.add(item);
      window.setTimeout(() => pointerActivatedDropdowns.delete(item));
      return;
    }

    if (item) return;
    document.querySelectorAll(`${dropdownSelector}.is-open`).forEach((item) => closeDropdown(item));
  });
}
